import client from "./instance";

// Feat: CR027 - Get Service Status API
// รายละเอียด: API สำหรับเช็คสถานะ service (เปิด/ปิด) และ รายชื่อของ tconnectId ที่อนุญาตให้ใช้งานได้
// วันที่: 2026-03-17

export const getServiceStatus = async () => {
  try {
    const response = await client.get("/cnf-parameter/getServiceStatus");
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
